export function getAuthorityListForPersonnelBoxesList(): Array<any> {
    let obj = [
        { path: 'boxes', isPrivateInfo: false, authorities: ['hrmSubMenuPersonnel'], adminAuth: '' },
        {
            path: 'vehicle',
            isPrivateInfo: false,
            authorities: ['hrmPersonnelMgmntVehicleDefinition', 'hrmPersonnelMgmntVehicleView'],
            adminAuth: '',
            isManagerCanSee: true,
        },
        {
            path: 'degree',
            isPrivateInfo: false,
            authorities: ['hrmPersonnelMgmntDegreeDefinition', 'hrmPersonnelMgmntDegreeView'],
            adminAuth: '',
            isManagerCanSee: true,
        },
        {
            path: 'telephone',
            isPrivateInfo: true,
            authorities: [
                'hrmPersonnelMgmntPhoneDefinition',
                'hrmPersonnelMgmntPhoneView',
                'hrmPersonnelMgmntPhoneAdmin',
            ],
            adminAuth: 'hrmPersonnelMgmntPhoneAdmin',
            isManagerCanSee: true,
        },
        {
            path: 'trip',
            isPrivateInfo: true,
            authorities: ['hrmPersonnelMgmntTripView', 'hrmPersonnelMgmntTripAdmin'],
            adminAuth: 'hrmPersonnelMgmntTripAdmin',
            isManagerCanSee: true,
        },
        {
            path: 'physical-standard',
            isPrivateInfo: true,
            authorities: [
                'hrmPersonnelMgmntPhysicalStandardDefinition',
                'hrmPersonnelMgmntPhysicalStandardView',
                'hrmPersonnelMgmntPhysicalStandardAdmin',
            ],
            adminAuth: 'hrmPersonnelMgmntPhysicalStandardAdmin',
            isManagerCanSee: true,
        },
        {
            path: 'experience',
            isPrivateInfo: true,
            authorities: [
                'hrmPersonnelMgmntExperienceDefinition',
                'hrmPersonnelMgmntExperienceView',
                'hrmPersonnelMgmntExperienceAdmin',
            ],
            adminAuth: 'hrmPersonnelMgmntExperienceAdmin',
            isManagerCanSee: true,
        },
        {
            path: 'weapon',
            isPrivateInfo: false,
            authorities: ['hrmPersonnelMgmntWeaponDefinition', 'hrmPersonnelMgmntWeaponView'],
            adminAuth: '',
            isManagerCanSee: true,
        },
        {
            path: 'per-foreign-language',
            isPrivateInfo: false,
            authorities: ['hrmPersonnelMgmntForeignLanguageDefinition', 'hrmPersonnelMgmntForeignLanguageView'],
            adminAuth: '',
            isManagerCanSee: true,
        },
        {
            path: 'contract',
            isPrivateInfo: false,
            authorities: ['hrmPersonnelMgmntContractBilgisiDefinition', 'hrmPersonnelMgmntContractBilgisiView'],
            adminAuth: '',
            isManagerCanSee: true,
        },
        {
            path: 'exam',
            isPrivateInfo: false,
            authorities: ['hrmPersonnelMgmntExamDefinition', 'hrmPersonnelMgmntExamView'],
            adminAuth: '',
            isManagerCanSee: true,
        },
        {
            path: 'identity',
            isPrivateInfo: true,
            authorities: [
                'hrmPersonnelMgmntIdentityDefinition',
                'hrmPersonnelMgmntIdentityView',
                'hrmPersonnelMgmntIdentityAdmin',
            ],
            adminAuth: 'hrmPersonnelMgmntIdentityAdmin',
            isManagerCanSee: true,
        },
        {
            path: 'military',
            isPrivateInfo: true,
            authorities: [
                'hrmPersonnelMgmntMilitaryDefinition',
                'hrmPersonnelMgmntMilitaryView',
                'hrmPersonnelMgmntMilitaryAdmin',
            ],
            adminAuth: 'hrmPersonnelMgmntMilitaryAdmin',
            isManagerCanSee: true,
        },
        {
            path: 'historical-data',
            isPrivateInfo: false,
            authorities: ['hrmPersonnelMgmntHistoricalDataDefinition', 'hrmPersonnelMgmntHistoricalDataView'],
            adminAuth: '',
            isManagerCanSee: true,
        },
        {
            path: 'court',
            isPrivateInfo: false,
            authorities: ['hrmPersonnelMgmntCourtDefinition', 'hrmPersonnelMgmntCourtView'],
            adminAuth: '',
            isManagerCanSee: true,
        },
        {
            path: 'education',
            isPrivateInfo: true,
            authorities: [
                'hrmPersonnelMgmntEducationDefinition',
                'hrmPersonnelMgmntEducationView',
                'hrmPersonnelMgmntEducationAdmin',
            ],
            adminAuth: 'hrmPersonnelMgmntEducationAdmin',
            isManagerCanSee: true,
        },
        {
            path: 'bank',
            isPrivateInfo: false,
            authorities: ['hrmPersonnelMgmntBankAccountDefinition', 'hrmPersonnelMgmntBankAccountView'],
            adminAuth: '',
            isManagerCanSee: true,
        },
        {
            path: 'address',
            isPrivateInfo: false,
            authorities: ['hrmPersonnelMgmntAddressDefinition', 'hrmPersonnelMgmntAddressView'],
            adminAuth: '',
            isManagerCanSee: true,
        },
        {
            path: 'syndicate',
            isPrivateInfo: false,
            authorities: ['hrmPersonnelMgmntSyndicateDefinition', 'hrmPersonnelMgmntSyndicateView'],
            adminAuth: '',
            isManagerCanSee: true,
        },
        {
            path: 'certificate',
            isPrivateInfo: true,
            authorities: [
                'hrmPersonnelMgmntCertificateDefinition',
                'hrmPersonnelMgmntCertificateView',
                'hrmPersonnelMgmntCertificateAdmin',
            ],
            adminAuth: 'hrmPersonnelMgmntCertificateAdmin',
            isManagerCanSee: true,
        },
        {
            path: 'identification',
            isPrivateInfo: false,
            authorities: [
                'hrmPersonnelMgmntIdentificationDefinition',
                'hrmPersonnelMgmntIdentificationView',
                'hrmPersonnelMgmntIdentityAdmin',
            ],
            adminAuth: 'hrmPersonnelMgmntIdentityAdmin',
            isManagerCanSee: true,
        },
        {
            path: 'special-situation',
            isPrivateInfo: false,
            authorities: ['hrmPersonnelMgmntSpecialSituationDefinition', 'hrmPersonnelMgmntSpecialSituationView'],
            adminAuth: '',
            isManagerCanSee: true,
        },
        {
            path: 'personnel-organization',
            isPrivateInfo: true,
            authorities: [
                'hrmPersonnelMgmntOrganizationDefinition',
                'hrmPersonnelMgmntOrganizationView',
                'hrmPersonnelMgmntOrganizationAdmin',
            ],
            adminAuth: 'hrmPersonnelMgmntOrganizationAdmin',
            isManagerCanSee: true,
        },
        {
            path: 'award',
            isPrivateInfo: true,
            authorities: [
                'hrmPersonnelMgmntAwardDefinition',
                'hrmPersonnelMgmntAwardView',
                'hrmPersonnelMgmntAwardAdmin',
            ],
            adminAuth: 'hrmPersonnelMgmntAwardAdmin',
            isManagerCanSee: true,
        },
        {
            path: 'borrowing',
            isPrivateInfo: false,
            authorities: ['hrmPersonnelMgmntBorrowingDefinition', 'hrmPersonnelMgmntBorrowingDefinition'],
            adminAuth: '',
            isManagerCanSee: true,
        },
        {
            path: 'external',
            isPrivateInfo: false,
            authorities: ['hrmPersonnelMgmntExternalServiceDefinition', 'hrmPersonnelMgmntExternalServiceView'],
            adminAuth: '',
            isManagerCanSee: true,
        },
        {
            path: 'health',
            isPrivateInfo: true,
            authorities: [
                'hrmPersonnelMgmntHealthDefinition',
                'hrmPersonnelMgmntHealthView',
                'hrmPersonnelMgmntHealthAdmin',
            ],
            adminAuth: 'hrmPersonnelMgmntHealthAdmin',
            isManagerCanSee: true,
        },
        {
            path: 'absence-entry',
            isPrivateInfo: false,
            authorities: [
                'hrmPersonnelMgmntTimeManagementDefinition',
                'hrmPersonnelMgmntTimeManagementView',
                'hrmPersonnelMgmntTimeManagementAdmin',
            ],
            adminAuth: 'hrmPersonnelMgmntTimeManagementAdmin',
            isManagerCanSee: true,
        },
        {
            path: 'time-management',
            isPrivateInfo: true,
            authorities: [
                'hrmPersonnelMgmntTimeManagementDefinition',
                'hrmPersonnelMgmntTimeManagementView',
                'hrmPersonnelMgmntTimeManagementAdmin',
            ],
            adminAuth: 'hrmPersonnelMgmntTimeManagementAdmin',
            isManagerCanSee: true,
        },
        {
            path: 'absence-quota',
            isPrivateInfo: true,
            authorities: [
                'hrmPersonnelMgmntTimeManagementDefinition',
                'hrmPersonnelMgmntTimeManagementView',
                'hrmPersonnelMgmntTimeManagementAdmin',
            ],
            adminAuth: 'hrmPersonnelMgmntTimeManagementAdmin',
            isManagerCanSee: true,
        },
        {
            path: 'attendance-master',
            isPrivateInfo: true,
            authorities: [
                'hrmPersonnelMgmntTimeManagementDefinition',
                'hrmPersonnelMgmntTimeManagementView',
                'hrmPersonnelMgmntTimeManagementAdmin',
            ],
            adminAuth: 'hrmPersonnelMgmntTimeManagementAdmin',
            isManagerCanSee: true,
        },
        {
            path: 'overtime',
            isPrivateInfo: true,
            authorities: [
                'hrmPersonnelMgmntTimeManagementDefinition',
                'hrmPersonnelMgmntTimeManagementView',
                'hrmPersonnelMgmntTimeManagementAdmin',
            ],
            adminAuth: 'hrmPersonnelMgmntTimeManagementAdmin',
            isManagerCanSee: true,
        },
        {
            path: 'payroll-integration',
            isPrivateInfo: true,
            authorities: [
                'hrmPersonnelMgmntTimeManagementDefinition',
                'hrmPersonnelMgmntTimeManagementView',
                'hrmPersonnelMgmntTimeManagementAdmin',
            ],
            adminAuth: 'hrmPersonnelMgmntTimeManagementAdmin',
            isManagerCanSee: true,
        },
        {
            path: 'flexible-working-report',
            isPrivateInfo: true,
            authorities: [
                'hrmPersonnelMgmntTimeManagementDefinition',
                'hrmPersonnelMgmntTimeManagementView',
                'hrmPersonnelMgmntTimeManagementAdmin',
            ],
            adminAuth: 'hrmPersonnelMgmntTimeManagementAdmin',
            isManagerCanSee: true,
        },
        {
            path: 'work-schedule',
            isPrivateInfo: true,
            authorities: [
                'hrmPersonnelMgmntTimeManagementDefinition',
                'hrmPersonnelMgmntTimeManagementView',
                'hrmPersonnelMgmntTimeManagementAdmin',
            ],
            adminAuth: 'hrmPersonnelMgmntTimeManagementAdmin',
            isManagerCanSee: true,
        },
        {
            path: 'project-info',
            isPrivateInfo: true,
            authorities: ['kovan:hr:time-management:personnel-master-data:tm-project-info'],
            isManagerCanSee: true,
        },
        {
            path: 'punishment',
            isPrivateInfo: true,
            authorities: [
                'hrmPersonnelMgmntPunishmentDefinition',
                'hrmPersonnelMgmntPunishmentView',
                'hrmPersonnelMgmntPunishmentAdmin',
            ],
            adminAuth: 'hrmPersonnelMgmntPunishmentAdmin',
            isManagerCanSee: true,
        },
        {
            path: 'family',
            isPrivateInfo: true,
            authorities: [
                'hrmPersonnelMgmntFamilyDefinition',
                'hrmPersonnelMgmntFamilyView',
                'hrmPersonnelMgmntFamilyAdmin',
            ],
            adminAuth: 'hrmPersonnelMgmntFamilyAdmin',
            isManagerCanSee: true,
        },
        {
            path: 'disability',
            isPrivateInfo: false,
            authorities: ['hrmPersonnelMgmntDisabilityDefinition', 'hrmPersonnelDisabilityView'],
            adminAuth: '',
            isManagerCanSee: true,
        },
        {
            path: 'suspension',
            isPrivateInfo: false,
            authorities: ['hrmSubMenuTimeManagement'],
            adminAuth: '',
            isManagerCanSee: true,
        },
        {
            path: 'movement',
            isPrivateInfo: true,
            authorities: [
                'hrmPersonnelMgmntMovementDefinition',
                'hrmPersonnelMgmntMovementView',
                'hrmPersonnelMgmntMovementAdmin',
            ],
            adminAuth: 'hrmPersonnelMgmntMovementAdmin',
            isManagerCanSee: true,
        },
        {
            path: 'wage-management',
            isPrivateInfo: true,
            authorities: ['hrmPayrollDefinition', 'hrmPersonnelMgmntWageTypeView'],
            adminAuth: 'hrmPayrollDefinition',
        },
        {
            path: 'attachment',
            isPrivateInfo: false,
            authorities: ['hrmSubMenuPersonnel'],
            adminAuth: '',
            isManagerCanSee: true,
        },
        {
            path: 'movement-info',
            isPrivateInfo: false,
            authorities: [
                'hrmPersonnelMgmntMovementDefination',
                'hrmPersonnelMgmntMovementAdmin',
                'hrmPersonnelMgmntMovementAdminView',
            ],
            adminAuth: 'hrmPersonnelMgmntMovementAdminView',
            isManagerCanSee: true,
        },
        {
            path: 'payroll-cards',
            isPrivateInfo: true,
            authorities: ['hrmPayrollDefinition'],
            adminAuth: 'hrmPayrollDefinition',
        },
        {
            path: 'declaration-goods',
            isPrivateInfo: true,
            authorities: [
                'hrmPersonnelMgmntDeclarationGoodsAdmin',
                'hrmPersonnelMgmntDeclarationGoodsView',
                'hrmPersonnelMgmntDeclarationGoodsDefinition',
            ],
            adminAuth: 'hrmPersonnelMgmntDeclarationGoodsAdmin',
            isManagerCanSee: false,
        },
    ];
    return obj;
}

export function getAuthorityByPath(pathName: string) {
    let findObj = getAuthorityListForPersonnelBoxesList().find(
        (obj) => obj.path == pathName && obj.isPrivateInfo == true,
    );
    if (findObj == undefined) {
        return false;
    }
    return findObj;
}
